import {useCurrentPageType} from '@aboutyou/router';
import {useMemo} from 'react';
import {useOutfitIdentifier} from '../../../shared-deprecated/useOutfitIdentifier';
import {useProductIdentifier} from '../../../shared-deprecated/useProductIdentifier';
import {useStoryIdentifier} from '../../../shared-deprecated/useStoryIdentifier';
import {useBrandShopIdentifierFooter as useBrandPageIdentifierFooter} from '../utils/useBrandPageIdentifierFooter';
import {useCategoryIdentifierFooter} from '../utils/useCategoryIdentifierFooter';

export const useFooterIdentifier = () => {
  const categoryIdentifier = useCategoryIdentifierFooter();
  const productIdentifier = useProductIdentifier();
  const brandPageIdentifierFooter = useBrandPageIdentifierFooter();
  const outfitIdentifier = useOutfitIdentifier();
  const storyIdentifier = useStoryIdentifier();
  const isHome = useCurrentPageType() === 'home';

  return useMemo(() => {
    if (categoryIdentifier) {
      return {
        $case: 'category' as const,
        category: categoryIdentifier,
      };
    }

    if (productIdentifier) {
      return {
        $case: 'product' as const,
        product: {
          identifier: productIdentifier,
        },
      };
    }

    if (brandPageIdentifierFooter) {
      return {
        $case: 'brandPage' as const,
        brandPage: brandPageIdentifierFooter,
      };
    }

    if (storyIdentifier) {
      return {
        $case: 'story' as const,
        story: {
          identifier: storyIdentifier,
        },
      };
    }

    if (outfitIdentifier) {
      return {
        $case: 'outfit' as const,
        outfit: {
          identifier: outfitIdentifier,
        },
      };
    }

    if (isHome) {
      return {
        $case: 'browsePage' as const,
        browsePage: {},
      };
    }

    return null;
  }, [
    brandPageIdentifierFooter,
    categoryIdentifier,
    outfitIdentifier,
    productIdentifier,
    storyIdentifier,
    isHome,
  ]);
};
